import { CalculatorEducationalContent } from "./educational/types";
import { taxEducationalContent } from "./educational/tax";
import { loansEducationalContent } from "./educational/loans";
import { investmentsEducationalContent } from "./educational/investments";
import { retirementEducationalContent } from "./educational/retirement";
import { savingsEducationalContent } from "./educational/savings";

export * from "./educational/types";

const calculatorEducationalDb: Record<string, CalculatorEducationalContent> = {
  ...taxEducationalContent,
  ...loansEducationalContent,
  ...investmentsEducationalContent,
  ...retirementEducationalContent,
  ...savingsEducationalContent,
};

export function getCalculatorEducationalContent(slug: string): CalculatorEducationalContent | undefined {
  return calculatorEducationalDb[slug];
}
